import { render, staticRenderFns } from "./MakeKindField.vue?vue&type=template&id=1173a7a4"
import script from "./MakeKindField.vue?vue&type=script&lang=js"
export * from "./MakeKindField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports